import React, { type FunctionComponent } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { DashSwitch } from 'legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from 'legacy/dash-components/dash-redirect/DashRedirect'
import { useCurrentAccountDetails } from 'api/current-account/currentAccount.hooks'
import { AdminSection } from 'sections/admin/AdminSection'
import { DASH_ROUTE_URLS } from 'utils/routing/routes'
import { HaltSection } from 'sections/halt/HaltSection'
import { AppAdminSectionAccessControl } from 'sections/admin/AdminSection.configuration'
import { DevPortalSection } from 'sections/dev-portal/DevPortalSection'
import { AppDevPortalSectionAccessControl } from 'sections/dev-portal/DevPortalSection.configuration'
import { CurrentAccountProvider } from 'utils/current-account/CurrentAccountProvider'

export const AppRoutes: FunctionComponent = () => {
  const { loading, authorized, actionRequired } = useCurrentAccountDetails()
  const haltAccountActionRequiredMatch = useRouteMatch(
    DASH_ROUTE_URLS['app-halt-account-action-required']
  )

  if (loading) {
    return null
  }

  // If not authorized, return them to the landing page so they can log in
  if (!authorized) {
    return <DashRedirect toRoute="public-log-in" />
  }

  // If there is some setup still required, block them from accessing the core app
  // We want to redirect them if they aren't already on the action-required page
  if (!actionRequired && !haltAccountActionRequiredMatch) {
    return <DashRedirect toRoute="app-halt-account-action-required" />
  }

  return (
    <CurrentAccountProvider>
      <DashSwitch>
        <DashRoute route="app-halt" component={HaltSection} />

        <DashRoute
          route="app-admin"
          component={AdminSection}
          accessControl={AppAdminSectionAccessControl}
        />
        <DashRoute
          route="app-dev-portal"
          component={DevPortalSection}
          accessControl={AppDevPortalSectionAccessControl}
        />

        <DashRedirect toRoute="app-halt-redirect" />
      </DashSwitch>
    </CurrentAccountProvider>
  )
}
